/* kstent-install-confidence.js
 * モーダル開閉・focus trap・iframe 動的生成
 * 仕様: .ars-state/spec-kstent-pdp-install-confidence-20260508.md
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var CARD_SELECTOR = '.kstent-install-confidence__video-card';
  var DIALOG_ID = 'kstent-ic-modal';

  var state = {
    dialog: null,
    iframe: null,
    iframeWrap: null,
    closeBtn: null,
    backBtn: null,
    previousFocus: null
  };

  function buildDialog() {
    var dlg = document.createElement('dialog');
    dlg.id = DIALOG_ID;
    dlg.className = 'kstent-install-confidence__modal';
    dlg.setAttribute('aria-label', '動画モーダル');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('role', 'dialog');

    var frame = document.createElement('div');
    frame.className = 'kstent-install-confidence__modal-frame';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'kstent-install-confidence__modal-close';
    closeBtn.setAttribute('aria-label', '動画を閉じる');
    closeBtn.innerHTML = '<span aria-hidden="true">×</span>';

    var iframeWrap = document.createElement('div');
    iframeWrap.className = 'kstent-install-confidence__modal-iframe-wrap';

    var bottom = document.createElement('div');
    bottom.className = 'kstent-install-confidence__modal-bottom';

    var backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'kstent-install-confidence__modal-back-btn';
    backBtn.textContent = '閉じて商品ページに戻る';

    var hint = document.createElement('p');
    hint.className = 'kstent-install-confidence__modal-esc-hint';
    hint.textContent = 'Esc キー / 背景タップでも閉じられます';

    bottom.appendChild(backBtn);
    bottom.appendChild(hint);
    frame.appendChild(closeBtn);
    frame.appendChild(iframeWrap);
    frame.appendChild(bottom);
    dlg.appendChild(frame);
    document.body.appendChild(dlg);

    state.dialog = dlg;
    state.iframeWrap = iframeWrap;
    state.closeBtn = closeBtn;
    state.backBtn = backBtn;

    closeBtn.addEventListener('click', closeModal);
    backBtn.addEventListener('click', closeModal);

    dlg.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeModal();
    });

    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) closeModal();
    });

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') trapFocus(e);
    });
  }

  function ensureDialog() {
    if (!state.dialog) buildDialog();
  }

  function extractYouTubeId(input) {
    if (!input) return '';
    var s = String(input).trim();
    if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
    var m = s.match(/[?&]v=([A-Za-z0-9_-]{11})/);
    if (m) return m[1];
    m = s.match(/youtu\.be\/([A-Za-z0-9_-]{11})/);
    if (m) return m[1];
    m = s.match(/youtube(?:-nocookie)?\.com\/embed\/([A-Za-z0-9_-]{11})/);
    if (m) return m[1];
    return s;
  }

  function openModal(youtubeId, title, triggerEl) {
    ensureDialog();
    state.previousFocus = triggerEl || document.activeElement;

    youtubeId = extractYouTubeId(youtubeId);

    while (state.iframeWrap.firstChild) {
      state.iframeWrap.removeChild(state.iframeWrap.firstChild);
    }

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(youtubeId) + '?autoplay=1&rel=0&modestbranding=1';
    iframe.title = title || 'YouTube 動画';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'eager');
    iframe.className = 'kstent-install-confidence__modal-iframe';
    iframe.addEventListener('error', function () {
      state.iframeWrap.innerHTML = '<p style="color:#fff;padding:24px;text-align:center;">再生に失敗しました。<a href="https://www.youtube.com/watch?v=' + encodeURIComponent(youtubeId) + '" target="_blank" rel="noopener noreferrer" style="color:#fff;text-decoration:underline;">YouTube で開く</a></p>';
    });
    state.iframeWrap.appendChild(iframe);
    state.iframe = iframe;

    if (typeof state.dialog.showModal === 'function') {
      state.dialog.showModal();
    } else {
      state.dialog.setAttribute('open', '');
    }
    document.body.style.overflow = 'hidden';

    setTimeout(function () {
      if (state.closeBtn) state.closeBtn.focus();
    }, 50);
  }

  function closeModal() {
    if (!state.dialog) return;
    if (typeof state.dialog.close === 'function') {
      try { state.dialog.close(); } catch (_e) { state.dialog.removeAttribute('open'); }
    } else {
      state.dialog.removeAttribute('open');
    }
    if (state.iframe && state.iframe.parentNode) {
      state.iframe.parentNode.removeChild(state.iframe);
    }
    state.iframe = null;
    document.body.style.overflow = '';
    if (state.previousFocus && typeof state.previousFocus.focus === 'function') {
      try { state.previousFocus.focus(); } catch (_e) {}
    }
    state.previousFocus = null;
  }

  function trapFocus(e) {
    if (!state.dialog) return;
    var focusable = state.dialog.querySelectorAll(
      'button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function bindCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll(CARD_SELECTOR);
    cards.forEach(function (card) {
      if (card.dataset.kicBound === '1') return;
      card.dataset.kicBound = '1';
      card.addEventListener('click', function (e) {
        var youtubeId = card.getAttribute('data-kic-video-id');
        var title = card.getAttribute('data-kic-video-title') || '';
        if (!youtubeId) return;
        e.preventDefault();
        openModal(youtubeId, title, card);
      });
    });
  }

  function init() {
    bindCards(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) bindCards(e.target);
  });
})();
